import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type LuggageHotelIconProps = CreateIconComponentProps;
export const LuggageHotelIcon: React.FC<LuggageHotelIconProps> = ({
  title = 'LuggageHotel',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <circle
      cx="5.5"
      cy="20.5"
      r="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
    <circle
      cx="18.5"
      cy="20.5"
      r="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2.047"
      d="M2.024 17.977h19.953"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 18v-7c0-3.866-3.07-7-6.857-7h-2.286C7.07 4 4 7.134 4 11v7"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.5 11v-.667C10.5 9.597 11.172 9 12 9s1.5.597 1.5 1.333V11"
    />
    <path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M7 12h10v6H7z" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2v2"
    />
  </CreateIconComponent>
);
